<template>
    <v-layout justify-center>
        <v-responsive max-width="1024" width="100%">
            <list-heading title="교육서비스 메인설정" />

            <v-data-table v-bind="{ loading, headers, items, itemClass }" item-key="_id" :items-per-page="-1" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined" style="overflow: hidden" ref="data-table">
                <template #body="props">
                    <draggable v-if="$refs['data-table']" tag="tbody" :list="props.items" draggable=".draggable-item" :disabled="loading" @change="setNewIndex">
                        <v-nodes :vnodes="$refs['data-table'].genItems(props.items, props)" />
                    </draggable>
                </template>

                <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value)" /> </template>

                <template #[`item.main.isActive`]="{ item }">
                    <v-switch v-model="item.main.isActive" v-bind="attrs_switch__console" @change="(isActive) => update({ _id: item._id, _parent: item._parent, main: { index: item.main.index, isActive } })" />
                </template>
            </v-data-table>

            <v-fade-transition>
                <v-overlay v-show="loading" light color="white">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { attrs_switch__console } from "@/assets/variables";

import Draggable from "vuedraggable";
import ListHeading from "@/components/console/dumb/list-heading.vue";

export default {
    components: {
        VNodes: { functional: true, render: (h, ctx) => ctx.props.vnodes },
        Draggable,
        ListHeading,
    },
    data: () => ({
        categories: [],

        loading: false,

        attrs_switch__console,
    }),
    computed: {
        headers() {
            return [
                {
                    text: "#",
                    value: "main.index",
                    width: +80,
                    align: "right",
                },
                {
                    text: "카테고리명",
                    value: "fullName",
                },
                {
                    text: "메인노출",
                    value: "main.isActive",
                    width: 160,
                    align: "center",
                },
            ].map((item, index, array) => ({
                ...item,
                divider: index != array.length - 1,
                cellClass: item.cellClass + ` caption`,
                formatter: item.formatter ?? ((value) => value ?? "-"),
            }));
        },
        items() {
            return [...this.categories];
        },
    },
    methods: {
        async init() {
            this.categories = [];
            this.loading = false;
            this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { categories } = await api.console.lectures.categories.gets({
                    headers: {
                        sort: JSON.stringify({
                            "main.isActive": -1,
                            "main.index": 1,
                            depth: 1,
                            index: 1,
                        }),
                    },
                });
                this.categories = categories;
            } finally {
                this.loading = false;
            }
        },

        async update(item) {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { category } = await api.console.lectures.categories.put(item);
                if (this.loading) this.loading = false;
                this.updateItem(category);
            } finally {
                if (this.loading) this.loading = false;
            }
        },

        async updateItem(item) {
            const index = this.categories.findIndex(({ _id }) => _id == item._id);
            if (-1 < index) this.categories.splice(index, 1, item);
            this.search();
        },

        async setNewIndex({ moved = {} }) {
            let {
                element: {
                    _id,
                    main: { isActive, index },
                },
                oldIndex,
                newIndex,
            } = moved;
            index += newIndex - oldIndex;
            let form = { _id, main: { isActive, index } };
            this.update(form);
        },

        itemClass(item) {
            return { ["draggable-item"]: item?.main?.isActive };
        },
    },
    mounted() {
        this.init();
    },
};
</script>
